var map = {
	"./de_DE.json": 45234,
	"./en_GB.json": 93332,
	"./en_US.json": 17661,
	"./pl_PL.json": 90480
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 25079;
module.exports = webpackAsyncContext;